import Auth0Identity from './sdk/identity';
export default Auth0Identity;
